import { useState } from "react";
import AgentNavbar from "../../component/AgentNavbar";  
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import Swal from "sweetalert2";
import RequestTopUpGateway from "./AgentComp/RequestTopUpGateway";

function RequestTopUp() {
  const agentid = localStorage.getItem("agent_id");
  const [amount, setAmount] = useState("");
  const [transactionId, setTransactionId] = useState(""); // New state
  const [loading, setLoading] = useState(false);

  const handleTopUpRequest = async (e) => {
    e.preventDefault();

    // Validate Amount and Transaction ID
    if (!amount || amount <= 0) {
      Swal.fire({
        title: "Invalid Amount!",
        text: "Please enter a valid amount greater than zero.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!transactionId.trim()) {
      Swal.fire({
        title: "Missing Transaction ID!",
        text: "Please enter the Transaction ID of your payment.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setLoading(true);

    const requestData = {
      agent_id: agentid,
      amount: amount,
      transaction_id: transactionId, // Include transaction ID
    };

    console.log("Sending Data to Backend:", requestData);

    try {
      const response = await axios.post(`${baseurl}addAgentRequest`, requestData);

      console.log("Response Data:", response.data);

      Swal.fire({
        title: "Top-Up Request Sent!",
        text: "Your request has been submitted successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      setAmount("");
      setTransactionId(""); // Clear transaction ID input
    } catch (error) {
      console.error("Top-Up Request Error:", error.response ? error.response.data : error.message);

      Swal.fire({
        title: "Error!",
        text: "Failed to send top-up request. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid pt-3">
          <div className="crdmain">
            <div className="row">
              <div className="col-md-6">
                <div className="d-flex justify-content-between align-items-center">
                  <h1 className="title text-start">💰 Request Wallet Top-Up To TopAirview</h1>
                </div>


                <div className="text-start">
                  <div><strong>Bank Name:</strong> Bank Name here</div>
                  <div><strong>IFSC Code:</strong> IFSC Code here</div>
                  <div><strong>Account Number:</strong> Account Number here</div>
                </div>

                <form onSubmit={handleTopUpRequest} className="p-4 border rounded bg-white">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3 text-start">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          min="1"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 text-start">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Transaction ID"
                          value={transactionId}
                          onChange={(e) => setTransactionId(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? "Submitting..." : "Request Top-Up"}
                    </button>
                  </div>
                </form>
              </div>

              <div className="col-md-6">
                <div className="d-flex justify-content-between align-items-center">
                  <h1 className="title text-start">💰 Request Using Phone Pay</h1>
                </div>

                <RequestTopUpGateway />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RequestTopUp;
